export default __webpack_public_path__ + "static/media/support.fbbd3a5d.svg";